import { CurrentPositionType } from '@/common/components/base/map/map.type';
import { MapSearchLocationQueryResponseType } from '@/common/queries/mapSearchLocation/mapSearchLocationQuery.type';
import { fetchApi } from '@/config/axiosSetting.ts';

export const mapSearchLocationFunction = (
  params: CurrentPositionType,
): Promise<MapSearchLocationQueryResponseType> => {
  return fetchApi.get('map/get_address_with_latlng/', {
    params: { lat: params.lat, lon: params.lng },
  });
};
